/*
|--------------------------------------------------------------------------
| Utilities: WEATHER
|--------------------------------------------------------------------------
*/
__gh__webApp.utilities.weather = {
	"init":function(){
		var currentDomain = __gh__coreData.siteData.baseURL;
		// remove .load for #toprail-weather and #drawer-weather
	}
};
